import { Chip, Tooltip } from '@mui/material';

const StatusColorMap = {
  Active: 'chipPrimary',
  Inactive: 'chipSecondary',
  Invited: 'chipTertiary',
  Unverified: 'chipWarning',
};

const StatusTooltipMap = {
  Active: 'This team member can access the Installer Portal.',
  Inactive: 'This team member no longer has access to the Installer Portal.',
  Invited: 'We have sent an email inviting this team member to join.',
  Unverified:
    'This team member started signing up but has not confirmed their email yet.',
};

type Props = {
  status?: string | null;
};

export default function ContactStatusChip({ status }: Props) {
  if (!status || !StatusColorMap[status] || !StatusTooltipMap[status]) {
    return null;
  }

  return (
    <Tooltip arrow title={StatusTooltipMap[status]} enterTouchDelay={0}>
      <Chip label={status} color={StatusColorMap[status]} />
    </Tooltip>
  );
}
